import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import OutbOrd02Actions, { OutbOrd02Types } from '../Stores/OutbOrd02/Actions';

const getAppStore = state => state.app;

export function* outbOrd02FetchOutbOrd02({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(OutbOrd02Actions.outbOrd02FetchOutbOrd02Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `outbOrd/indexProcess/OUTB_ORD_02/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        OutbOrd02Actions.outbOrd02FetchOutbOrd02Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd02Actions.outbOrd02FetchOutbOrd02Loading(false));
  }
}

export function* outbOrd02CreateOutbOrd02({ hdrIds }) {
  try {
    yield put(OutbOrd02Actions.outbOrd02CreateOutbOrd02Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `outbOrd/createProcess/OUTB_ORD_02`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(OutbOrd02Actions.outbOrd02CreateOutbOrd02Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd02Actions.outbOrd02CreateOutbOrd02Loading(false));
  }
}

export function* outbOrd02GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/lspSlsOrdDetail/update/${hdrId}`));
}

export function* outbOrd02NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/lspSlsOrdDetail/create/${app.curDivisionId}`));
}

export function* outbOrd02CheckStock({ hdrIds }) {
  try {
    yield put(OutbOrd02Actions.outbOrd02CreateOutbOrd02Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `lspSlsOrd/checkStock`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'CHECK_STOCK.XLSX');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd02Actions.outbOrd02CreateOutbOrd02Loading(false));
  }
}

export const saga = [
  takeLatest(OutbOrd02Types.OUTB_ORD02_FETCH_OUTB_ORD02, outbOrd02FetchOutbOrd02),
  takeLatest(OutbOrd02Types.OUTB_ORD02_CREATE_OUTB_ORD02, outbOrd02CreateOutbOrd02),
  takeLatest(OutbOrd02Types.OUTB_ORD02_GO_TO_DOCUMENT, outbOrd02GoToDocument),
  takeLatest(OutbOrd02Types.OUTB_ORD02_NEW_DOCUMENT, outbOrd02NewDocument),
  takeLatest(OutbOrd02Types.OUTB_ORD02_CHECK_STOCK, outbOrd02CheckStock)
];
